export enum ScanType {
  Asset = 'Asset',
  User = 'User',
  Unknown = 'Unknown',
}
